// components/GalleryModal.js
import React, { useState, useEffect } from 'react';
import './GalleryModal.css'; // Will create this CSS file

function GalleryModal({ images, initialIndex, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  useEffect(() => {
    setCurrentIndex(initialIndex); // Update index if initialIndex changes (e.g., new image clicked)
  }, [initialIndex]);

  const currentImage = images[currentIndex];

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const goToPrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  if (!currentImage) return null; // Don't render if no image is selected

  return (
    <div className="gallery-modal-overlay" onClick={onClose}>
      <div className="gallery-modal-content" onClick={(e) => e.stopPropagation()}> {/* Prevent closing when clicking inside */}
        <button className="gallery-modal-close" onClick={onClose}>&times;</button>
        <img src={currentImage.src} alt={currentImage.title} className="gallery-modal-image" />
        <div className="gallery-modal-controls">
          <button className="gallery-modal-nav prev" onClick={goToPrev}>&#10094;</button>
          <button className="gallery-modal-nav next" onClick={goToNext}>&#10095;</button>
        </div>
        <div className="gallery-modal-info">
          {currentImage.title} ({currentIndex + 1} of {images.length})
        </div>
      </div>
    </div>
  );
}

export default GalleryModal;
